/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { EMPTY, Subject, timer } from 'rxjs';
import { catchError, switchMap, takeUntil } from 'rxjs/operators';
import { AppStatus } from './app-status.model';

const STATUS_API_URL = 'https://twybkz9smjh2.statuspage.io/api/v2/status.json';
const POLLING_INTERVAL = 60000;

@Injectable({
  providedIn: 'root',
})
export class AppStatusService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private initialized = false;
  private http: HttpClient;

  constructor(private httpBackend: HttpBackend) {
    this.http = new HttpClient(httpBackend);
  }

  initializeAppStatus(): void {
    if (this.initialized) {
      return;
    }
    this.initialized = true;

    timer(0, POLLING_INTERVAL)
      .pipe(
        switchMap(() =>
          this.http.get<AppStatus>(STATUS_API_URL).pipe(
            catchError(() => EMPTY)
          )
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((response: AppStatus) => {
        sessionStorage.setItem('status', response.status.indicator);
        sessionStorage.setItem('description', response.status.description);
        window.dispatchEvent(new Event('status-notification-event'));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.initialized = false;
  }
}
